import React, { useContext, useEffect, Fragment, useState } from "react";
import { useParams } from "react-router-dom";
import Select from "react-select";
import { DocumentoContext } from "../DocumentoContext";
import Formulario from "../../../../../Components/Cadastro/Formulario/Formulario";
import FormularioComplementar from "../../../../../Components/Cadastro/FormularioComplementar/FormularioComplementar";
import DataTable from '../../../../../Components/DataTable/DataTable';
import TagsInput from '../Components/TagsInput';
import { removeItemFromArray } from '../../../../../Utils/globalFunctions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faDownload } from '@fortawesome/free-solid-svg-icons';

const initialStateGrupoUsuario = {
  id: 0,
  grupoUsuarioId: 0,
  grupoUsuarioNome: ''
}

const initialStateUsuario = {
  id: 0,
  usuarioId: 0,
  usuarioNome: ''
}

const initialStateDocumentoVinculado = {
  id: 0,
  docsId: 0,
  docsNome: ''
}

const FormularioDocumento = () => {
  const { values, setValues, getDetailHandler, handleDownloadArquivoFisico, showMessage, styleSelect, obterSubtipos } = useContext(DocumentoContext);
  const [grupoUsuarioValues, setGrupoUsuarioValues] = useState(initialStateGrupoUsuario);
  const [usuarioValues, setUsuarioValues] = useState(initialStateUsuario);
  const [documentoVinculadoValues, setDocumentoVinculadoValues] = useState(initialStateDocumentoVinculado);
  let { id } = useParams();

  useEffect(() => {
    getDetailHandler(Number(id) || 0);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  function onChangeInput(event) {
    const { name, value } = event.target;
    setValues({
      ...values,
      data: {
        ...values.data,
        [name]: value,
      },
    });
  }

  const handleChangeTipo = async (tipoDoc) => {

    const subtipos = await obterSubtipos(tipoDoc ? tipoDoc.value : 0)


    const subTiposDocs = subtipos
      .map((sub) => ({
        value: sub.subTipoDocsId,
        label: sub.subTipoDocsNome,
      }));

    setValues({
      ...values,
      subTiposDocs,
      data: {
        ...values.data,
        tipoDocsId: tipoDoc ? tipoDoc.value : 0,
        subTipoDocsId: 0,
      },
      tipoDoc,
      subTipo: {}
    });
  };


  const handleChangeSubTipo = (subTipo) => {
    setValues({
      ...values,
      data: {
        ...values.data,
        subTipoDocsId: subTipo ? subTipo.value : 0,
      },
      subTipo,
    });
  };

  function onFileChange(event) {
    const input = event && event.target ? event.target : null;
    const files = input && input.files ? input.files : [];
    if (!files || files.length === 0) return;

    const file = files[0];
    const nomeArquivo = file && file.name ? file.name : "";
    const mimeType = file && file.type ? file.type : "";
    const tamanho = file && typeof file.size !== "undefined" ? Number(file.size) : 0;

    var extensao = "";
    var ponto = nomeArquivo.lastIndexOf(".");
    if (ponto !== -1) {
      extensao = nomeArquivo.substring(ponto + 1).toLowerCase();
    }
    setValues({
      ...values,
      data: {
        ...values.data,
        docsNomeOrig: nomeArquivo,
        docsMimeType: mimeType,
        docsTamanho: tamanho,
        docsExtensao: extensao,
        arquivoSelecionado: file,
      },
    });
  }

  /*GRUPO DE USUARIO*/

  const columnsDefinitionGrupoUsuario = [
    {
      text: 'Id',
      dataField: 'grupoUsuarioId',
      hidden: true
    },
    {
      text: 'Grupo Usuário',
      dataField: 'grupoUsuarioNome',
      headerStyle: { width: '250px' },
      sort: true
    }
  ];

  function onChangeInputGrupoUsuario(event) {
    const value = event.target.value;
    const text = event.target.options[event.target.selectedIndex].text;
    setGrupoUsuarioValues({
      ...grupoUsuarioValues,
      id: value,
      grupoUsuarioId: value,
      grupoUsuarioNome: text
    });
  }

  const adionarGrupoUsuario = () => {
    let GrupoUsuarioJaAdiocionado = values.data.grupoUsuarioList.find(
      // eslint-disable-next-line eqeqeq
      (grupoUsuario) => grupoUsuario.grupoUsuarioId == grupoUsuarioValues.id
    );

    if (GrupoUsuarioJaAdiocionado) {
      showMessage('Alerta', 'Grupo de Usuário já incluído.');
      return;
    }

    var grupoUsuarioListNew = values.data.grupoUsuarioList;
    grupoUsuarioListNew.push(grupoUsuarioValues);
    setValues({
      ...values,
      data: {
        ...values.data,
        grupoUsuarioList: grupoUsuarioListNew
      }
    });

    setGrupoUsuarioValues(initialStateGrupoUsuario);
  };

  const removerGrupoUsuario = (id) => {
    var grupoUsuarioListNew = values.data.grupoUsuarioList;

    removeItemFromArray(grupoUsuarioListNew, grupoUsuarioListNew.find((usuario) => usuario.id === id));

    setValues({
      ...values,
      data: {
        ...values.data,
        grupoUsuarioList: grupoUsuarioListNew
      }
    });
  };



  /*USUARIO*/

  const columnsDefinitionUsuario = [
    {
      text: 'Id',
      dataField: 'usuarioId',
      hidden: true
    },
    {
      text: 'Usuário',
      dataField: 'usuarioNome',
      headerStyle: { width: '250px' },
      sort: true
    }
  ];


  function onChangeInputUsuario(event) {
    const value = event.target.value;
    const text = event.target.options[event.target.selectedIndex].text;
    setUsuarioValues({
      ...usuarioValues,
      id: value,
      usuarioId: value,
      usuarioNome: text
    });
  }

  const adionarUsuario = () => {
    let usuarioJaAdiocionado = values.data.usuarioList.find(
      // eslint-disable-next-line eqeqeq
      (usuario) => usuario.usuarioId == usuarioValues.id
    );

    if (usuarioJaAdiocionado) {
      showMessage('Alerta', 'Usuário já incluído.');
      return;
    }

    var usuarioListNew = values.data.usuarioList;
    usuarioListNew.push(usuarioValues);
    setValues({
      ...values,
      data: {
        ...values.data,
        usuarioList: usuarioListNew
      }
    });

    setUsuarioValues(initialStateUsuario);
  };

  const removerUsuario = (id) => {
    var usuarioListNew = values.data.usuarioList;

    removeItemFromArray(usuarioListNew, usuarioListNew.find((usuario) => usuario.id === id));

    setValues({
      ...values,
      data: {
        ...values.data,
        usuarioList: usuarioListNew
      }
    });
  };

  /* DOCUMENTO VINCULADO */

  const columnsDefinitionDocumentoVinculado = [
    {
      text: 'Id',
      dataField: 'docsId',
      hidden: true
    },
    {
      text: 'Documento',
      dataField: 'docsNome',
      headerStyle: { width: '250px' },
      sort: true
    }
  ];

  function onChangeInputDocumentoVinculado(event) {
    const value = event.target.value;
    const text = event.target.options[event.target.selectedIndex].text;
    setDocumentoVinculadoValues({
      ...documentoVinculadoValues,
      id: value,
      docsId: value,
      docsNome: text
    });
  }

  const adionarDocumentoVinculado = () => {
    let documentoJaAdiocionado = values.data.documentoList.find(
      // eslint-disable-next-line eqeqeq
      (doc) => doc.docsId == documentoVinculadoValues.id
    );

    if (documentoJaAdiocionado) {
      showMessage('Alerta', 'Documento já incluído.');
      return;
    }

    var documentoListNew = values.data.documentoList;
    documentoListNew.push(documentoVinculadoValues);
    setValues({
      ...values,
      data: {
        ...values.data,
        documentoList: documentoListNew
      }
    });

    setDocumentoVinculadoValues(initialStateDocumentoVinculado);
  };

  const removerDocumentoVinculado = (id) => {
    var documentoListNew = values.data.documentoList;

    removeItemFromArray(
      documentoListNew,
      documentoListNew.find((doc) => doc.id === id)
    );

    setValues({
      ...values,
      data: {
        ...values.data,
        documentoList: documentoListNew
      }
    });
  };



  return (
    <Fragment>
      <Formulario context={DocumentoContext}>


        <div className="col-6 form-group">
          <label>Nome<span className="campoObratorio">*</span></label>
          <input
            disabled={values.formDisabled}
            className="form-control uppercase"
            type="text"
            maxLength="90"
            name="docsNome"
            value={values.data.docsNome || ""}
            onChange={onChangeInput}
          />
        </div>

        <div className="col-3 form-group">
          <label>Status<span className="campoObratorio">*</span></label>
          <select
            disabled={values.formDisabled}
            className="form-control"
            name="docsStatus"
            value={values.data.docsStatus || ""}
            onChange={onChangeInput}
          >
            <option className="disabled"></option>
            <option value="A">Ativo</option>
            <option value="I">Inativo</option>
          </select>
        </div>

        <div className="col-3 form-group">
          <label>Confidencialidade<span className="campoObratorio">*</span></label>
          <select
            disabled={values.formDisabled}
            className="form-control"
            name="docsConfidencialidade"
            value={values.data.docsConfidencialidade || ""}
            onChange={onChangeInput}
          >
            <option className="disabled"></option>
            <option value="P">Público</option>
            <option value="R">Restrito</option>
            <option value="C">Confidencial</option>
          </select>
        </div>
        <div className="col-3 form-group">
          <label>Tipo</label>
          <Select
            isDisabled={values.formDisabled}
            styles={styleSelect}
            placeholder=""
            value={values.tipoDoc}
            onChange={handleChangeTipo}
            options={values.tiposDocs}
          />
        </div>
        <div className="col-3 form-group">
          <label>Sub Tipo<span className="campoObratorio">*</span></label>
          <Select
            isDisabled={values.formDisabled}
            styles={styleSelect}
            placeholder=""
            value={values.subTipo}
            onChange={handleChangeSubTipo}
            options={values.subTiposDocs}
          />
        </div>

        <div className="col-12 col-md-3 form-group">
          <label>Validade</label>
          <input
            disabled={values.formDisabled}
            className="form-control"
            type="date"
            name="docsDataValidade"
            value={values.data.docsDataValidade || ""}
            onChange={onChangeInput}
          />
        </div>

        {/* Linha 3: Descrição */}
        <div className="col-12 form-group">
          <label>Descrição</label>
          <textarea
            disabled={values.formDisabled}
            className="form-control"
            name="docsDescricao"
            rows={4}
            maxLength="3000"
            value={values.data.docsDescricao || ""}
            onChange={onChangeInput}
          />
        </div>

        <div className="col-10 ">
          <label>Arquivo<span className="campoObratorio">*</span></label>
          <div className="custom-file">
            <input
              disabled={values.formDisabled}
              type="file"
              className="custom-file-input"
              id={`customFileUpload`}
              name="leadEmail"
              onChange={onFileChange}
            />
            <label
              className="custom-file-label selected"
              htmlFor={`customFileUpload`}
            >
              {" "}
              {values.data.docsNomeOrig || ""}
            </label>
          </div>
        </div>
        {values.data.docsPath && values.data.docsExtensao ? <div className="col-2">
          <button
            style={{ marginTop: '20px' }}
            type="button"
            className="btn btn-primary"
            onClick={() => handleDownloadArquivoFisico(`${values.data.docsPath}.${values.data.docsExtensao}`, values.data.docsNomeOrig)}
          >
            <FontAwesomeIcon style={{ fontSize: 10, marginRight: 5 }} icon={faDownload} /> Baixar
          </button>
        </div> : null}
      </Formulario>
      <FormularioComplementar titulo="Tags" >
        <TagsInput
          disabled={values.formDisabled}
          value={values.data.docsTags || ""}
          onChange={(newValue) =>
            onChangeInput({ target: { name: "docsTags", value: newValue } })
          }
        />
      </FormularioComplementar>
      <Fragment>
        <div className="container-fluid">
          <div className="row">
            <div className="col-12">
              <div className="default-title">Permissões</div>
              <div className="card shadow-sm mb-4">
                <div className="row">

                  <div className="col-6 col-md-6">
                    <FormularioComplementar >
                      <div className="col-9 form-group">
                        <label>Grupo de Usuarios</label>
                        <select
                          disabled={values.formDisabled}
                          className="form-control"
                          name="grupoUsuarioId"
                          value={grupoUsuarioValues.grupoUsuarioId}
                          onChange={onChangeInputGrupoUsuario}
                        >
                          <option className="disabled" key="0" value="0"></option>
                          {values.grupoUsuarioList.map((grupoUsuario) => (
                            <option
                              key={grupoUsuario.grupoUsuarioId}
                              value={grupoUsuario.grupoUsuarioId}
                            >
                              {grupoUsuario.grupoUsuarioNome}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-3 form-group">
                        <button
                          disabled={values.formDisabled || grupoUsuarioValues.grupoUsuarioId === 0}
                          style={{ marginTop: '26px' }}
                          type="button"
                          className="btn btn-default buttonFormularios"
                          onClick={adionarGrupoUsuario}
                        >
                          Adicionar
                        </button>
                      </div>
                      <div className="col-12 col-md-12 form-group">
                        <DataTable
                          data={values.data.grupoUsuarioList}
                          columnsDefinition={columnsDefinitionGrupoUsuario}
                          removeHandler={values.formDisabled ? null : removerGrupoUsuario}
                          removerPaginacao={true}
                        />
                      </div>
                    </FormularioComplementar>
                  </div>
                  <div className="col-6 col-md-6">
                    <FormularioComplementar >
                      <div className="col-9 form-group">
                        <label>Usuarios</label>
                        <select
                          disabled={values.formDisabled}
                          className="form-control"
                          name="usuarioId"
                          value={usuarioValues.usuarioId}
                          onChange={onChangeInputUsuario}
                        >
                          <option className="disabled" key="0" value="0"></option>
                          {values.usuarioList.map((usuario) => (
                            <option key={usuario.usuarioId} value={usuario.usuarioId}>
                              {usuario.usuarioNome}
                            </option>
                          ))}
                        </select>
                      </div>

                      <div className="col-3 form-group">
                        <button
                          disabled={values.formDisabled || usuarioValues.usuarioId === 0}
                          style={{ marginTop: '26px' }}
                          type="button"
                          className="btn btn-default buttonFormularios"
                          onClick={adionarUsuario}
                        >
                          Adicionar
                        </button>
                      </div>
                      <div className="col-12 col-md-12 form-group">
                        <DataTable
                          data={values.data.usuarioList}
                          columnsDefinition={columnsDefinitionUsuario}
                          removeHandler={values.formDisabled ? null : removerUsuario}
                          removerPaginacao={true}
                        />
                      </div>
                    </FormularioComplementar>
                  </div>


                </div>
              </div>
            </div>
          </div>
        </div>

      </Fragment>


      <FormularioComplementar titulo="Arquivos Vinculados" >
        <div className="col-8 col-md-8 form-group">
          <label>Arquivos</label>
          <select
            disabled={values.formDisabled}
            className="form-control"
            name="docsId"
            value={documentoVinculadoValues.docsId}
            onChange={onChangeInputDocumentoVinculado}
          >
            <option className="disabled" key="0" value="0"></option>
            {values.documentoList.map((documento) => (
              <option key={documento.docsId} value={documento.docsId}>
                {documento.docsNome}
              </option>
            ))}
          </select>
        </div>

        <div className="col-4 col-md-4 form-group">
          <button
            disabled={values.formDisabled || documentoVinculadoValues.docsId === 0}
            style={{ marginTop: '26px' }}
            type="button"
            className="btn btn-default buttonFormularios"
            onClick={adionarDocumentoVinculado}
          >
            Adicionar
          </button>
        </div>
        <div className="col-12 col-md-12 form-group">
          <DataTable
            data={values.data.documentoList}
            columnsDefinition={columnsDefinitionDocumentoVinculado}
            removeHandler={values.formDisabled ? null : removerDocumentoVinculado}
            removerPaginacao={true}
          />
        </div>
      </FormularioComplementar>
    </Fragment >
  );
};

export default FormularioDocumento;
